export default __webpack_public_path__ + "static/media/E07.2dfdc9b6.mp3";